import React from 'react';
import { VictoryPie } from 'victory';
import { IChartCardLeftProps } from '.';

const BinaryLeft: React.FC<IChartCardLeftProps> = ({ helper }) => (
  <div className="h3 w3">
    <VictoryPie
      data={helper.pieChart().data}
      colorScale={helper.pieChart().colorsBinary}
      padding={0}
      labels={[]}
      animate={{
        duration: 500,
        onLoad: { duration: 750 }
      }}
    />
  </div>
);

export default BinaryLeft;
